import React from 'react'
import { Grid, Typography } from '@mui/material'
import { useStyles } from './style'

const Header = ({ title, actions }) => {
  const classes = useStyles()

  const Title = typeof title === 'string' ? <Typography variant='h6' noWrap>{title}</Typography> : title

  return (
    <Grid container wrap='nowrap' alignItems='center' className={classes.ctnTitle}>
      <Grid item>
        {Title}
      </Grid>
      <Grid container item justifyContent='flex-end' style={{ gap: '8px' }}>
        {actions}
      </Grid>
    </Grid>
  )
}

export default Header
